<template>
    <div class="side-nav" :class="{'hide':!sidebar.opened}" v-cloak>
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
            <el-menu-item v-for="router in menus" :key="router.rule_id" :index="`/${router.name}`"
                          v-if="router.type == 2">
                <i class="el-icon-menu"></i>
                <router-link :to="`/${router.name}`">{{ router.title }}</router-link>
            </el-menu-item>
            <el-submenu v-for="router in menus" :key="router.rule_id" :index="router.title" v-if="router.type == 3">
                <template slot="title">
                    <i class="el-icon-menu"></i>
                    {{ router.title }}
                </template>
                <el-menu-item v-for="child in router.children" :key="child.rule_id" :index="`/${child.name}`" v-if="child.type == 2">
                    <router-link :to="`/${child.name}/${child.rule_id}`">{{ child.title }}</router-link>
                </el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {headOfficeMenu} from '../config/routes'

export default {
    name: 'sideNav',
    data() {
        return {
            diningList: [],
            menus: [],
            accountInfo: {}
        }
    },
    computed: {
        ...mapGetters([
            'username',
            'avatar',
            'sidebar',
            'routers'
        ])
    },
    created() {
        // this.getDiningList();
        this.accountInfo = JSON.parse(localStorage.getItem('accountInfo'));
        if(this.accountInfo.type != 5){
            this.getMenuList();
        }else{
            // saas 代理商
            this.menus = [
                {name: 'saas/shop/info', title: '合作信息', type: 2},
                {name: 'saas/shop/data', title: '店铺数据', type: 2},
                {name: 'saas/order/data', title: '订单数据', type: 2},
                {name: 'saas/payment/progress', title: '打款进度', type: 2}
            ]
        }
    },
    methods: {
        handleOpen(key, keyPath) {
            // console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath);
        },
        getMenuList() {
            // 获取菜单权限
            this.$apiOuter.post(this.$apiUrl.getMenuList, {
                commercial_type: this.accountInfo.type + 1,
                rule_ids: this.accountInfo.rule_ids,
                is_child_account: this.accountInfo.pid == 0 ? 0 : 1
            }, (res) => {
                localStorage.setItem('menus', JSON.stringify(res.data));
                this.menus = res.data.children;
            }, null, 'manager-center')
        },
        getDiningList() {
            this.$api.post(this.$apiUrl.dinnerList, {school_id: localStorage.getItem('schoolId')}, (res) => {
                this.diningList = res.data;
                this.getMenuList();
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// SideNav.vue?6cb16d49